export default "__VITE_ASSET__CCKQq98W__"